export class Deuda {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo_credito: {
                value: null,
                export: false,
                table: true,
                header: 'TIPO DE CRÉDITO:',
                required: 'Tipo de crédito es requerido',
            },
            otro_tipo_credito: {
                value: '',
                export: false,
                table: false,
                header: 'OTRO TIPO DE CRÉDITO:',
                required: 'Otro tipo de crédito es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            }, 
            pais: {
                value: null,
                export: false,
                table: true,
                header: 'PAÍS DONDE SE LOCALIZA EL CRÉDITO:',
                required: 'País es requerido',
            },
            nombre_acreedor: {
                value: '',
                export: false,
                table: true,
                header: 'NOMBRE DEL ACREEDOR:',
                required: 'Nombre del acreedor es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },      
            valor: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'Valor USD:',
                required: 'Valor es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
